import { useMutation } from '@tanstack/react-query';
import { register, login, RegisterPayload, LoginPayload, AuthResponse } from '../api/authApi';

export function useRegister() {
  return useMutation<AuthResponse, Error, RegisterPayload>({
    mutationFn: register,
  });
}

export function useLogin() {
  return useMutation<AuthResponse, Error, LoginPayload>({
    mutationFn: login,
  });
}